import type { StatefulDiaryT } from "@/types/database/diaries";
import type { ExtendedInjectionViewT } from "@/types/database/events";

import { useDiaryByIdQuery } from "../../diaries/api/diaryQueries";

export function extractInjectionById(diary: StatefulDiaryT | undefined | null, injectionId: string) {
    console.log("--- Debugging extractInjectionById ---");
    console.log("Received diary object:", diary);
    console.log("Searching for injectionId:", injectionId);

    if (!diary) {
        console.log("Diary is null or undefined, returning.");
        return undefined;
    }

    const injections = diary?.events_view?.flatMap((e) => e?.injections_view).filter(Boolean);
    console.log("Extracted injections from events_view:", injections);

    const injection = injections?.find((inj) => inj?.injection_id === injectionId);

    console.log("Found matching injection:", injection);
    console.log("--------------------------------------");

    return injection;
}

const useExtractInjection = (diaryId: string, injectionId: string) => {
    const { data: diary } = useDiaryByIdQuery(diaryId);
    return extractInjectionById(diary, injectionId) as ExtendedInjectionViewT;
};

export default useExtractInjection;
